export const SHORTCUT_KEYS = Array.from({ length: 12 }, (_, index) => `F${index + 1}`);
export const SHORTCUT_DEFAULTS = {
  F1: 'Produk (admin)', F2: 'Kasir / pencarian', F3: 'Pelanggan', F4: 'Keranjang',
  F5: 'Muat ulang browser', F6: 'Bawaan browser / perangkat', F7: 'Bawaan browser / perangkat',
  F8: 'Pembayaran', F9: 'Bawaan browser / perangkat', F10: 'Bawaan browser / perangkat',
  F11: 'Layar penuh browser', F12: 'Bawaan browser / perangkat',
};
export function normalizeShortcut(value) {
  const parts = value.split('+').map(part => part.trim().toUpperCase().replace('CONTROL', 'CTRL'));
  const key = parts.pop(), original = parts;
  if (new Set(original).size !== original.length || original.some(mod => !['CTRL', 'ALT', 'SHIFT'].includes(mod))) throw new Error('Kombinasi tombol tidak dikenal');
  const mods = ['CTRL', 'ALT', 'SHIFT'].filter(mod => original.includes(mod));
  if (!mods.length && SHORTCUT_KEYS.includes(key)) return key;
  if (['F6', 'F7', 'F9', 'F10', 'F12'].includes(key) && ['CTRL', 'SHIFT', 'CTRL+SHIFT'].includes(mods.join('+')))
    return [...mods.map(mod => mod[0] + mod.slice(1).toLowerCase()), key].join('+');
  if (mods.join('+') === 'CTRL+ALT' && /^[A-Z0-9]$/.test(key)) return `Ctrl+Alt+${key}`;
  throw new Error('Bentrok/tidak didukung. Gunakan Shift+F9, Ctrl+F9, Ctrl+Shift+F9 atau Ctrl+Alt+huruf/angka. Control/Shift tunggal dan tombol input dilindungi.');
}
export function eventShortcut(event) {
  if (event.metaKey || event.getModifierState?.('AltGraph')) return null;
  try { return normalizeShortcut([event.ctrlKey && 'Ctrl', event.altKey && 'Alt', event.shiftKey && 'Shift', event.key].filter(Boolean).join('+')); }
  catch { return null; }
}
export function shortcutBinding(event, settings, catalog) {
  if (!settings?.enabled || event.defaultPrevented) return null;
  const key = eventShortcut(event);
  const binding = settings.bindings.find(item => item.key === key);
  return binding && catalog.some(item => item.to === binding.to) ? binding : null;
}
export function shortcutCatalog(groups) {
  const items = [];
  const visit = item => item.children ? item.children.forEach(visit) : items.push({ to: item.to, label: item.label });
  groups.forEach(group => group.items.forEach(visit));
  if (items.some(item => item.to === '/stok?tab=opname')) {
    items.push({ to: '/stok?tab=opname&action=quick', label: 'Stok Opname Cepat' });
  }
  return [...new Map(items.map(item => [item.to, item])).values()];
}
export function shortcutTarget(event, settings, catalog, dialogOpen) {
  if (!settings?.enabled || dialogOpen || event.defaultPrevented || event.repeat || event.isComposing) return null;
  if (event.target?.closest?.('input, textarea, select, [contenteditable]:not([contenteditable="false"])')) return null;
  return shortcutBinding(event, settings, catalog)?.to || null;
}
